var AlligatorView, Backbone, SupportCurrentOrderView, SupportHelpWizardController, SupportMainContentWrapperView, SupportProgressBarView, SupportStepActionsView, SupportStepOneActionsTemplate, SupportUtilsHelper, SupportV1SelectDifferentOrderMenuView, SupportV1StepOneView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportProgressBarView = require('../progress_bar_view');

SupportV1SelectDifferentOrderMenuView = require('../order_related/v1_select_different_order_menu_view');

SupportCurrentOrderView = require('../order_related/current_order_view');

SupportMainContentWrapperView = require('../main_content_view');

SupportStepActionsView = require('../step_actions_view');

SupportUtilsHelper = require('../../helpers/utils');

AlligatorView = require('../../../../shared/frontend/views/alligator_view');

SupportHelpWizardController = require('../../helpWizardController');

Backbone = require('backbone');

Backbone.$ = $;

SupportStepOneActionsTemplate = require('../../../step_one_actions.html.mustache');

SupportV1StepOneView = (function(superClass) {
  extend(SupportV1StepOneView, superClass);

  function SupportV1StepOneView() {
    return SupportV1StepOneView.__super__.constructor.apply(this, arguments);
  }

  SupportV1StepOneView.prototype.className = 'v1 step-one';

  SupportV1StepOneView.prototype.initialize = function() {
    this.id = 1;
    this.I18nScope = 'modules.support';
    Groupon.Support.Email = {};
    this.progressBar = new SupportProgressBarView;
    this.selectDifferentOrderMenu = new SupportV1SelectDifferentOrderMenuView;
    this.currentOrder = new SupportCurrentOrderView;
    this.stepActions = new SupportStepActionsView({
      template: SupportStepOneActionsTemplate
    });
    return this.mainContentWrappper = new SupportMainContentWrapperView;
  };

  SupportV1StepOneView.prototype.resetContentModelParams = function() {
    if (Groupon.Support.ContentModel != null) {
      Groupon.Support.ContentModel.escalateToMerchant = false;
      return Groupon.Support.ContentModel.isRefundEligible = false;
    }
  };

  SupportV1StepOneView.prototype.renderOrderDetails = function() {
    window.hideFooterLinks();
    this.resetContentModelParams();
    this.mainContentWrappper.render((function(_this) {
      return function(contentWrapper) {
        _this.renderProgressBar(contentWrapper);
        _this.renderSelectDifferentOrderMenu(contentWrapper);
        return _this.renderCurrentOrder(contentWrapper);
      };
    })(this));
    this.$el.html(this.mainContentWrappper.el);
    this.renderStepActions();
    return this.hideComponents();
  };

  SupportV1StepOneView.prototype.renderProgressBar = function(contentWrapper) {
    this.progressBar.render();
    contentWrapper.append(this.progressBar.el);
    return contentWrapper.append("<br>");
  };

  SupportV1StepOneView.prototype.renderSelectDifferentOrderMenu = function(contentWrapper) {
    this.selectDifferentOrderMenu.render();
    return contentWrapper.append(this.selectDifferentOrderMenu.el);
  };

  SupportV1StepOneView.prototype.renderCurrentOrder = function(contentWrapper) {
    this.currentOrder.render();
    return contentWrapper.append(this.currentOrder.el);
  };

  SupportV1StepOneView.prototype.renderStepActions = function() {
    this.stepActions.render();
    return this.$el.append(this.stepActions.el);
  };

  SupportV1StepOneView.prototype.hideComponents = function() {
    SupportUtilsHelper.hideFloatingBoldChat();
    return AlligatorView.hideWidgets();
  };

  SupportV1StepOneView.prototype.close = function() {
    return this.$el.empty();
  };

  SupportV1StepOneView.prototype.render = function(params) {
    var order, orderSummary;
    if (params == null) {
      params = {};
    }
    order = params.order;
    showLoading(this.$el);
    if (!Groupon.Support.OrdersCollection.hasOrders()) {
      return this.initOrdersFetch();
    } else if (order) {
      return this.getOrderDetails(order);
    } else {
      orderSummary = Groupon.Support.currentOrdersFilter.getFirstOrder();
      return this.getOrderDetails(orderSummary);
    }
  };

  SupportV1StepOneView.prototype.initOrdersFetch = function() {
    var _errorCb, _successCb;
    _successCb = (function(_this) {
      return function(orders) {
        return _this.myGrouponSuccessCallback(orders);
      };
    })(this);
    _errorCb = (function(_this) {
      return function() {
        return _this.loadOrderErrorCallback();
      };
    })(this);
    if (Groupon.Support.currentOrdersFilter.iterator.hasNext()) {
      return Groupon.Support.currentOrdersFilter.iterator.next(_successCb, _errorCb);
    } else {
      return _errorCb();
    }
  };

  SupportV1StepOneView.prototype.myGrouponSuccessCallback = function(orders) {
    var _errorCb, _successCb, order;
    if ((orders != null ? orders.length : void 0) > 0) {
      if (window.orderIdFromMyGroupons != null) {
        _successCb = (function(_this) {
          return function(orderDetails) {
            return _this.getOrderMetaData(orderDetails);
          };
        })(this);
        _errorCb = (function(_this) {
          return function() {
            return _this.loadOrderErrorCallback();
          };
        })(this);
        return Groupon.Support.OrderModel.getOrderDetailsForMygrouponsOrderId(_successCb, _errorCb);
      } else {
        order = Groupon.Support.currentOrdersFilter.getFirstOrder();
        return this.getOrderDetails(order);
      }
    } else if (Groupon.Support.currentOrdersFilter.iterator.hasNext()) {
      return this.initOrdersFetch();
    } else {
      return this.loadOrderErrorCallback();
    }
  };

  SupportV1StepOneView.prototype.getOrderDetails = function(orderSummary) {
    var _successCb, params;
    _successCb = (function(_this) {
      return function(orderDetails) {
        return _this.getOrderMetaData(orderDetails);
      };
    })(this);
    params = {
      order: orderSummary
    };
    return Groupon.Support.OrderModel.getOrderDetails(params, _successCb, _successCb);
  };

  SupportV1StepOneView.prototype.getOrderMetaData = function(orderDetails) {
    var _errorCb, _successCb, params;
    SupportHelpWizardController.changeCurrentOrder(orderDetails);
    if (orderDetails != null) {
      _successCb = (function(_this) {
        return function(order) {
          return _this.handleNormalAndMyGrouponsFlow(order);
        };
      })(this);
      _errorCb = (function(_this) {
        return function() {
          return _this.loadOrderErrorCallback();
        };
      })(this);
      Groupon.Support.MAXINDEX = 3;
      Groupon.Support.ORDER_NOT_LISTED = false;
      Groupon.Support.NOT_ORDER_RELATED = false;
      params = {
        order: orderDetails
      };
      return Groupon.Support.OrderModel.getMetadata(params, _successCb, _errorCb);
    }
  };

  SupportV1StepOneView.prototype.handleNormalAndMyGrouponsFlow = function(order) {
    if (window.selectOrderFromMygroupons) {
      return SupportHelpWizardController.stepTwo();
    } else {
      return this.renderOrderDetails();
    }
  };

  SupportV1StepOneView.prototype.loadOrderErrorCallback = function() {
    return SupportHelpWizardController.abruptStepTwoFlow();
  };

  return SupportV1StepOneView;

})(Backbone.View);

module.exports = SupportV1StepOneView;

//# sourceMappingURL=data:application/json;base64,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
